(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["domelyah-chiffon-content"]) return;
  try {
    
if (!customElements.get('dmch-review-carousel')) {
  customElements.define('dmch-review-carousel', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.grid = this.querySelector('.dmch-review-grid');
      this.cards = Array.from(this.querySelectorAll('.dmch-review-card'));
      if (!this.grid || !this.cards.length) return;
      this.previous = this.querySelector('[data-dmch-prev]');
      this.next = this.querySelector('[data-dmch-next]');
      this.current = this.querySelector('[data-dmch-current]');
      this.querySelector('[data-dmch-total]').textContent = this.cards.length;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.previous.addEventListener('click', () => this.move(this.index - 1), options);
      this.next.addEventListener('click', () => this.move(this.index + 1), options);
      this.grid.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }, { ...options, passive: true });
      this.grid.addEventListener('keydown', event => {
        if (event.target !== this.grid) return;
        const target = { ArrowLeft: this.index - 1, ArrowRight: this.index + 1, Home: 0, End: this.cards.length - 1 }[event.key];
        if (target === undefined) return;
        event.preventDefault();
        this.move(target);
      }, options);
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.grid);
      this.update();
      this.setAttribute('data-ready', '');
    }
    positions() {
      const first = this.cards[0].offsetLeft;
      const maximum = Math.max(0, this.grid.scrollWidth - this.grid.clientWidth);
      return this.cards.map(card => Math.min(maximum, Math.max(0, card.offsetLeft - first)));
    }
    update() {
      const positions = this.positions();
      this.index = positions.reduce((nearest, position, index) =>
        Math.abs(position - this.grid.scrollLeft) < Math.abs(positions[nearest] - this.grid.scrollLeft) ? index : nearest, 0);
      this.current.textContent = this.index + 1;
      this.previous.disabled = this.index === 0;
      this.next.disabled = this.index === this.cards.length - 1;
    }
    move(index) {
      const target = Math.max(0, Math.min(this.cards.length - 1, index));
      this.grid.scrollTo({
        left: this.positions()[target],
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["domelyah-cozyset-reviews"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('cozyset-reviews'))customElements.define('cozyset-reviews',class extends HTMLElement{
 connectedCallback(){if(this.started)return;this.started=true;this.limit=20;this.cards=Array.from(this.querySelectorAll('[data-review]'));this.filter=this.querySelector('[data-filter]');this.more=this.querySelector('[data-more]');this.dialog=this.querySelector('dialog');this.modal=this.querySelector('[data-modal]');this.cards.forEach((card,index)=>card.addEventListener('click',()=>this.open(index)));this.more.addEventListener('click',()=>{this.limit+=20;this.render()});this.filter.addEventListener('change',()=>{this.limit=20;this.render()});this.querySelector('[data-close]').addEventListener('click',()=>this.dialog.close());this.querySelector('[data-prev]').addEventListener('click',()=>this.open((this.index+this.cards.length-1)%this.cards.length));this.querySelector('[data-next]').addEventListener('click',()=>this.open((this.index+1)%this.cards.length));this.dialog.addEventListener('close',()=>this.cards[this.index]?.focus({preventScroll:true}));this.dialog.addEventListener('click',e=>{if(e.target!==this.dialog)return;const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close()});this.grid=this.querySelector('.dmco-r-grid');this.cards.forEach(card=>{const img=card.querySelector('img');if(img)img.addEventListener('load',()=>this.layout())});this.render();this.resizeObserver=new ResizeObserver(()=>this.layout());this.resizeObserver.observe(this.grid)}
 disconnectedCallback(){this.resizeObserver?.disconnect()}
 layout(){if(!this.grid||!this.grid.clientWidth)return;const width=this.grid.clientWidth;const columns=width<600?2:width<900?3:4;const gap=14;const cardWidth=(width-gap*(columns-1))/columns;const heights=Array(columns).fill(0);this.grid.dataset.masonry='';this.cards.filter(card=>!card.hidden).forEach(card=>{card.style.position='absolute';card.style.width=`${cardWidth}px`;const column=heights.indexOf(Math.min(...heights));card.style.left=`${column*(cardWidth+gap)}px`;card.style.top=`${heights[column]}px`;heights[column]+=card.offsetHeight+gap});const height=Math.max(...heights)-gap;if(this.grid.style.height!==`${Math.max(0,height)}px`)this.grid.style.height=`${Math.max(0,height)}px`}
 render(){let count=0;this.cards.forEach(card=>{const match=this.filter.value==='all'||card.dataset.rating===this.filter.value;card.hidden=!match||++count>this.limit});this.more.hidden=count<=this.limit;this.layout()}
 open(index){this.index=index;this.modal.replaceChildren(...Array.from(this.cards[index].children).map(el=>el.cloneNode(true)));if(!this.dialog.open)this.dialog.showModal()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["domelyah-review-preview"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('domelyah-review-feed')) {
  customElements.define('domelyah-review-feed', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.grid = this.querySelector('[data-grid]');
      this.more = this.querySelector('[data-more]');
      this.filter = this.querySelector('[data-filter]');
      this.counter = this.querySelector('[data-count-output]');
      this.dialog = this.querySelector('dialog');
      this.limit = 20;
      this.filter.disabled = true;
      this.more.addEventListener('click', () => { this.limit += 20; this.render(); });
      this.filter.addEventListener('change', () => { this.limit = 20; this.render(); });
      this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) { const rect = this.dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close(); } });
      this.dialog.addEventListener('close', () => { this.querySelector('[data-dialog-media]').replaceChildren(); this.lastCard?.focus({preventScroll:true}); });
      this.querySelector('[data-previous]').addEventListener('click', () => {this.photoIndex = (this.photoIndex + this.selected.images.length - 1) % this.selected.images.length;this.renderMedia();});
      this.querySelector('[data-next]').addEventListener('click', () => {this.photoIndex = (this.photoIndex + 1) % this.selected.images.length;this.renderMedia();});
      fetch(this.dataset.source).then(r => {if (!r.ok) throw Error('reviews');return r.json();}).then(reviews => {this.reviews = reviews; this.filter.disabled = false;this.render();}).catch(() => {this.counter.textContent = '';});
    }
    stars(rating) {
      const el = document.createElement('div');el.className='dm-rv-stars';el.setAttribute('aria-label',`${rating} / 5`);el.textContent='★'.repeat(rating);const empty=document.createElement('span');empty.textContent='★'.repeat(5-rating);empty.setAttribute('aria-hidden','true');el.append(empty);return el;
    }
    render() {
      const list = this.reviews.filter(r => this.filter.value === 'all' || String(r.rating) === this.filter.value);
      const fragment = document.createDocumentFragment();
      list.slice(0,this.limit).forEach(review => {
        const card=document.createElement('article');card.className='dm-rv-card';card.dataset.reviewId=review.id;card.tabIndex=0;card.setAttribute('role','button');card.setAttribute('aria-label',`${this.dataset.read} ${review.author}`);
        if (review.images.length) {
          const wrap=document.createElement('div');wrap.className='dm-rv-image';const image=document.createElement('img');image.src=review.images[0];image.alt=`${this.dataset.photo} ${review.author}`;image.loading='lazy';image.decoding='async';wrap.append(image);
          if(review.images.length>1||review.video){const count=document.createElement('span');count.className='dm-rv-image-count';count.textContent=review.video?'▶':`+${review.images.length-1}`;wrap.append(count);}card.append(wrap);
        }
        const copy=document.createElement('div');copy.className='dm-rv-copy';const author=document.createElement('strong');author.textContent=review.author;const quote=document.createElement('p');quote.textContent=review.quote;copy.append(author,this.stars(review.rating),quote);card.append(copy);
        card.addEventListener('click',()=>this.openReview(review,card));card.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();this.openReview(review,card);}});fragment.append(card);
      });
      this.grid.replaceChildren(fragment);this.more.hidden=this.limit>=list.length;this.counter.textContent=`${Math.min(this.limit,list.length)} / ${list.length} ${this.dataset.count}`;
    }
    openReview(review,card) {
      this.selected=review;this.photoIndex=0;this.lastCard=card;const copy=this.querySelector('[data-dialog-copy]');const author=document.createElement('strong');author.textContent=review.author;const quote=document.createElement('p');quote.textContent=review.quote;copy.replaceChildren(author,this.stars(review.rating),quote);this.renderMedia();this.dialog.showModal();
    }
    renderMedia() {
      const review=this.selected;const container=this.querySelector('[data-dialog-media]');container.replaceChildren();
      if(review.video){const video=document.createElement('iframe');video.src=review.video.replace('autoplay=true','autoplay=false');video.title=`${this.dataset.read} ${review.author}`;video.allow='fullscreen; picture-in-picture';video.allowFullscreen=true;video.style.cssText='display:block;width:100%;height:55vh;border:0';container.append(video);}
      else if(review.images.length){const image=document.createElement('img');image.src=review.images[this.photoIndex];image.alt=`${this.dataset.photo} ${review.author}`;container.append(image);}
      this.querySelector('[data-media-nav]').hidden=review.images.length<2;this.querySelector('[data-media-count]').textContent=`${this.photoIndex+1} / ${review.images.length}`;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
